import { Directive, DirectiveBinding } from 'vue';
import REQUIRED_PRIVILEGES from '@/constants/required-privileges';
import { RoleProtectedFeature } from '@/enums/feature-names';
import { Privilege } from '@/enums/privilege';
import { hasAnyPrivilege } from '@/helpers/has-any-privilege';

const PrivilegeDirective: Directive<HTMLElement, RoleProtectedFeature> = (
    element: HTMLElement,
    binding: DirectiveBinding<RoleProtectedFeature>
): void => {
    const requiredPrivileges: Privilege[] = REQUIRED_PRIVILEGES[binding.value];

    const hasPrivilege: boolean = hasAnyPrivilege(requiredPrivileges);

    if (hasPrivilege) {
        return;
    }

    element.remove();
};

export default PrivilegeDirective;
